module.exports = __webpack_public_path__ + "img/simplifi-logo.8e4bc151.png";